import React, { Fragment, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import PropTypes from "prop-types";
import FontAwesomeIcon from "../IME/Icon";
// import { cn } from '../../utilities/classNames';
import ToggleButton from "../../PlayerButtons/ToggleButton";
// import Selector from '../Selector/Selector';
import VolumeRed from "./VolumeRed";
import ProgressRed from "./ProgressRed";

import { evaluate } from "../../../utilities/props";

let socket;

const MentorStreamVideo = ({ time, videoduration, showChat, profile }) => {
  const ENDPOINT = "localhost:5000";

  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const playerRef = useRef(null);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  // const [, setSubtitle] = useState(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  useEffect(() => {
    socket = io(ENDPOINT);

    socket.on("stream", (video) => {
      videoRef.src = video;
    });

    return () => {
      socket.emit("disconnect");

      socket.off();
    };
  }, [ENDPOINT]);

  return (
    <Fragment>
      <div className="live-stream-video-container grey" ref={playerRef}>
        <div
          className={
            showOverlay ? "alt-video-overlay" : "alt-video-overlay-pause"
          }
        >
          <div className="user-overlay-info">
            <div className="avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${profile.avatar}`}
                className="streamer-user-avi"
              />
            </div>
            <div className="helper-container">
              <div className="stream-description-alt">
                <p className="stream-username-title">
                  <span className="red mr-5 description-font">
                    {profile.channelid}
                  </span>
                  <span className="white description-font-alt">
                    {profile.jobtitle}
                  </span>
                </p>
                <p className="stream-p-description">
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nam
                  ratione aut eaque dolor ea temporibus laboriosam laborum
                  recusandae odio omnis.
                </p>
                <div className="viewers">
                  <i className="fas fa-user fa-lg action-icon-user mr-5 red"></i>
                  <span className="white bold">Views</span>{" "}
                  <span className="white bold mx-5">811,332</span>
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              showChat ? "video-stream-live red" : "video-stream-live-chat red"
            }
          >
            <i className="fas fa-circle mx-5"></i>
            Live
          </div>
          <div className="alt-left-controls">
            <ul className="controls">
              <VolumeRed
                className="Rac__volume"
                onChange={(level) => {
                  const volume = level / 100;
                  videoRef.current.volume = volume;
                  videoRef.current.muted = volume === 0;
                }}
              />
            </ul>
          </div>
          <ToggleButton
            className="alt-center-controls"
            value={() => videoRef.current && !videoRef.current.paused}
            onChange={(active) => {
              if (!active) {
                return videoRef.current.pause();
              }

              return videoRef.current.play();
            }}
          >
            {(active) => {
              if (currentTime > 0.1 && currentTime < duration && active) {
                setshowOverlay(true);
                return (
                  <i
                    className="far fa-pause-circle red fa-4x"
                    onClick={(e) => videoRef.current.pause()}
                  ></i>
                );
              } else {
                setshowOverlay(false);
              }
              if (currentTime === duration) {
                setCurrentTime(0);
              } else if (currentTime === 0 && !active) {
                return (
                  <i
                    className="far fa-play-circle red fa-4x"
                    onClick={(e) => videoRef.current.play()}
                  ></i>
                  // <FontAwesomeIcon

                  //   icon="play"
                  //   size="3x"
                  //   className="red"
                  // />
                );
              }
              return (
                <i
                  className="far fa-play-circle red fa-4x"
                  onClick={(e) => videoRef.current.play()}
                ></i>
              );
            }}
          </ToggleButton>
          <ProgressRed
            className="Rac__progress-bar"
            initial={0}
            time={currentTime}
            duration={duration}
            onSkip={(time) => (videoRef.current.currentTime = time)}
          />
          <div className="icon-flex-expand-settings">
            <ToggleButton
              className="Rac__screen-toggle"
              initial={document.fullscreenElement}
              onChange={(active) => {
                if (!active && KeyboardEvent.key === "Escape") {
                  return document.exitFullscreen();
                }

                return playerRef.current.requestFullscreen({
                  navigationUI: "hide",
                });
              }}
            >
              {(active) => {
                if (!active) {
                  return (
                    <FontAwesomeIcon
                      icon="expand"
                      size="lg"
                      className="mt-4 red"
                    />
                  );
                }

                if (active) {
                  return (
                    <FontAwesomeIcon
                      icon="compress"
                      size="lg"
                      className="mt-4 red"
                    />
                  );
                }
              }}
            </ToggleButton>
            <ToggleButton className="">
              {(showSettings) => {
                if (showSettings) {
                  return (
                    <div className="relative-button-container">
                      <li className="control red">
                        <i className="fas fa-cog fa-lg icon-padding"></i>
                      </li>
                      <div className="video-settings">
                        <ul className="video-setting">
                          <li className="video-option red bold">Quality</li>
                          <li className="video-option white cursor">
                            Auto
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option red bold">Caption</li>
                          <li className="video-option white cursor">
                            Off
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option red bold">
                            Report Issue
                          </li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                        <ul className="video-setting">
                          <li className="video-option red bold">Advanced</li>
                          <li className="video-option white cursor">
                            <i className="fas fa-chevron-right white mx-10"></i>
                          </li>
                        </ul>
                      </div>
                    </div>
                  );
                }

                return (
                  <div className="relative-button-container">
                    <li className="control red">
                      <i className="fas fa-cog fa-lg icon-padding"></i>
                    </li>
                  </div>
                );
              }}
            </ToggleButton>
          </div>
        </div>
        <img ref={videoRef} />
      </div>
    </Fragment>
  );
};

MentorStreamVideo.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
};

export default MentorStreamVideo;
